import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#start', label: '首页' },
  { href: '#timeline', label: '事件时间线' },
  { href: '#topics', label: '热点追踪' },
  { href: '#facts', label: '真相梳理' },
  { href: '#faq', label: '常见问题' },
  { href: '#about', label: '关于我们' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'}`}>
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#start" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg"></i>
          </span>
          <span className="heading-font text-xl font-bold text-foreground-950">海角吃瓜</span>
        </a>
        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} className="whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:block">
          <a href="#subscribe" className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600">
            关注进展
          </a>
        </div>
        <button type="button" aria-label="打开菜单" onClick={() => setOpen((v) => !v)} className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden">
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </div>
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block whitespace-nowrap border-b border-background-100 py-3 text-sm font-medium text-foreground-700 last:border-0">
              {l.label}
            </a>
          ))}
          <a href="#subscribe" onClick={() => setOpen(false)} className="mt-3 block whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50">
            关注进展
          </a>
        </div>
      )}
    </header>
  );
}